export const GET_DISTRIBUTORS_RESPONSE = {
  Distributors: 'Distributors',
  TokenError: 'TokenError',
};
